// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__tbNgd","copyright":"footer_copyright__XKGsZ","link-to":"footer_link-to__bUEo1"};